<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight order-children-detail order-taking">
        <!-- 提请结单[[ -->
        <div
            class="g-popup g-popup-transparent js-popup-statement"
            v-if="authorOrderInfoDialog.show"
            style="z-index: 100"
        >
            <div class="popup-con confirm-zero-popup popup-statement-con">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="authorOrderInfoDialog.show = false"></i>
                </div>
                <h5 class="popup-title">提请结单</h5>
                <p class="confim-content">
                    请再次确认关联人及金额，提请结束后将不可更改金额
                    <br>关联人总金额需同实际额一致
                </p>
                <div class="order-details">
                    <div class="order-type-num f-clearfix">
                        <div class="order-types f-fl order-types-left">
                            <div class="order-type">
                                图文:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.articlesPass }}/</span>
                                    {{ authorOrderInfo.articlesPre }}
                                </div>
                            </div>
                            <div class="order-type">
                                小说:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.novelPass }}/</span>
                                    {{ authorOrderInfo.novelPre }}
                                </div>
                            </div>
                            <div class="order-type">
                                视频:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.videoPass }}/</span>
                                    {{ authorOrderInfo.videoPre }}
                                </div>
                            </div>
                            <div class="order-type">
                                漫画:
                                <div class="num-details">
                                    <span class="num">{{ authorOrderInfo.cartoonPass }}/</span>
                                    {{ authorOrderInfo.cartoonPre }}
                                </div>
                            </div>
                        </div>
                        <div class="order-types f-fr">
                            <div class="order-type">
                                含税总预算:
                                <div
                                    class="num-details"
                                >{{ $common.toThousandsFilter(authorOrderInfo.totalBudgetTax)}}</div>
                            </div>
                            <div class="order-type">
                                含税实际额:
                                <div
                                    class="num-details color-theme"
                                >{{ $common.toThousandsFilter(authorOrderInfo.realConfirmAmount)}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="statement-list-box g-scrollbar">
                        <ul class="statement-list">
                            <li
                                class="statement-list-con"
                                v-for="person in relativePersonList"
                                :key="person"
                            >
                                <div class="list-con-left f-inlineblock-middle">
                                    <p
                                        class="list-con-name f-hide-col-1"
                                    >{{ person.login_user_name }}</p>
                                    <p class="list-con-id f-hide-col-1">{{ person.login_name }}</p>
                                </div>
                                <div class="list-con-center f-inlineblock-middle">
                                    <p class="list-con-text f-hide-col-2">{{ person.task_remark }}</p>
                                </div>
                                <div class="list-con-right f-inlineblock-middle">
                                    <span class="list-con-sign">&yen;</span>
                                    <input
                                        class="list-con-money g-input"
                                        type="text"
                                        v-model="person.amount"
                                        @change="saveRelativePerson(person)"
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btn-group f-clearfix">
                    <a
                        class="g-btn statement-btn"
                        href="javascript:;"
                        @click="doSubmitAuthorOrder(authorOrderInfo.id)"
                    >提请结单</a>
                    <a
                        class="g-btn cancell f-fr"
                        href="javascript:;"
                        @click="authorOrderInfoDialog.show = false"
                    >取消</a>
                </div>
            </div>
        </div>
        <!-- 提请结单]] -->

        <div class="order-message f-clearfix">
            <img
                class="order-detail-header f-fl"
                :src="authorOrderInfo.logoUrl"
                width="80"
                height="80"
            >
            <div class="order-detail-intro f-fr">
                <div class="order-name-contain f-clearfix">
                    <span class="order-name f-hide-col-1">{{ authorOrderInfo.order_name }}</span>
                    <span class="status f-fr">{{ authorOrderInfo.orderStatusText }}</span>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">
                        单号:
                        <span class="order-num-detail">{{ authorOrderInfo.id }}</span>
                    </div>
                    <div class="budget-all" style="width: 200px">
                        含税总预算:
                        <div class="budget-all-num" style="color: #666666">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(authorOrderInfo.totalBudgetTax)}}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num" style="color: #666666">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(authorOrderInfo.totalBudget) }}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥ {{ $common.toThousandsFilter(authorOrderInfo.budgetTax) }} 已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">
                        类型:
                        <span class="order-num-detail">{{ authorOrderInfo.demandTypeText }}</span>
                    </div>
                    <div class="budget-all" style="width: 200px">
                        含税实际额:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(authorOrderInfo.realAmountTax)}}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(authorOrderInfo.realAmount) }}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥ {{ $common.toThousandsFilter( authorOrderInfo.realTax) }} 已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-time-line">
                    <div class="order-num">
                        时间:
                        <span
                            class="order-num-detail"
                        >{{authorOrderInfo.start_time }}-{{authorOrderInfo.end_time }}</span>
                    </div>
                    <div class="budget-all">
                        单价:
                        <div class="contain f-hide-col-1">
                            <div class="budget-all-num">
                                视频
                                <span class="money-ico">￥</span>
                                <span class="money-num">400</span>/篇;
                            </div>
                            <div class="budget-all-num">
                                图文
                                <span class="money-ico">￥</span>
                                <span class="money-num">150</span>/篇;
                            </div>
                            <div class="budget-all-num">
                                小说
                                <span class="money-ico">￥</span>
                                <span class="money-num">250</span>/篇;
                            </div>
                            <div class="budget-all-num">
                                漫画
                                <span class="money-ico">￥</span>
                                <span class="money-num">250</span>/篇;
                            </div>
                        </div>
                        <div class="answer-show">
                            <i class="triangle"></i>
                            <div class="answer-text">视频￥400/篇； 图文￥150/篇； 小说￥250/篇；漫画￥400/篇；</div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-num-line">
                    小说：
                    <span class="order-num-detail">{{ authorOrderInfo.novelPre }}</span>
                    视频：
                    <span class="order-num-detail">{{ authorOrderInfo.videoPre }}</span>
                    漫画：
                    <span class="order-num-detail">{{ authorOrderInfo.cartoonPre }}</span>
                    图文：
                    <span class="order-num-detail">{{ authorOrderInfo.articlesPre }}</span>
                </div>
                <div class="order-lines order-tips-line">
                    <div class="order-num">
                        说明:
                        <span
                            class="order-num-detail f-hide-col-1"
                        >{{ authorOrderInfo.cycle_explain }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="commit-task g-autofixheight order-taking-detail">
            <div class="g-tab">
                <a
                    href="javascript:;"
                    v-for="(item,index) in tabList"
                    :key="index"
                    @click="changeTab(index)"
                >
                    <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item}}</div>
                </a>
            </div>
            <!-- 关联人及金额[[ -->
            <div class="order-detail-status order-detail-status-1" v-if="curTab==0">
                <div class="searchs-list">
                    <div class="search f-clearfix">
                        <p
                            class="list f-fl list-title f-hide-col-1"
                        >请设置订单关联人及税后实收（税费系统自动计算代缴）,订单关联人可见该订单，协同制作内容</p>
                        <div class="search-btn f-fr">
                            <a
                                class="g-btn js-relevance-btn"
                                href="javascript:;"
                                @click="importTeamMember"
                                v-if="authorOrderInfo.isReceiver && authorOrderInfo.order_status == 6002"
                            >导入团员</a>
                            <a
                                class="g-btn js-relevance-btn"
                                href="javascript:;"
                                @click="showAddPersonBox"
                                v-if="authorOrderInfo.isReceiver && authorOrderInfo.order_status == 6002"
                            >添加关联人</a>
                        </div>
                    </div>
                    <div class="searchs-table-box">
                        <table class="searchs-table">
                            <tr class="searchs-table-head">
                                <th class="searchs-table-relevance">关联人</th>
                                <th class="searchs-table-receipts">税后实收</th>
                                <th class="searchs-table-explain">任务说明</th>
                                <th class="searchs-table-state">状态</th>
                                <th class="searchs-table-operation">操作</th>
                            </tr>

                            <!-- searchs-table-tr下标为偶数的添加class="bg-gray" -->
                            <tr class="searchs-table-add searchs-table-tr" v-if="addBox.show">
                                <td class="searchs-table-relevance">
                                    <input
                                        class="searchs-table-input g-input"
                                        type="text"
                                        placeholder="请输入关联人QQ"
                                        v-model="addBox.qq"
                                    >
                                </td>
                                <td class="searchs-table-receipts searchs-table-td">
                                    <input
                                        class="searchs-table-input g-input"
                                        type="text"
                                        v-model="addBox.amount"
                                        placeholder="请输入金额"
                                    >
                                </td>
                                <td class="searchs-table-explain searchs-table-td">
                                    <input
                                        class="searchs-table-input g-input"
                                        type="text"
                                        v-model="addBox.remark"
                                        placeholder="请输入任务说明"
                                    >
                                </td>
                                <td class="searchs-table-state">
                                    <p></p>
                                </td>
                                <td class="searchs-table-operation">
                                    <a
                                        class="g-btn bg-orange js-operation-hold"
                                        href="javascript:;"
                                        @click="saveAddPersonBox"
                                    >保存</a>
                                    <a
                                        class="g-btn js-operation-delete"
                                        href="javascript:;"
                                        @click="resetAddBox"
                                    >删除</a>
                                </td>
                            </tr>

                            <tr
                                class="searchs-table-tr"
                                v-for="relativePerson in relativePersonList"
                                :key="relativePerson"
                            >
                                <td class="searchs-table-relevance searchs-table-td">
                                    <div
                                        class="f-inlineblock-middle relevance-con"
                                        v-if="!relativePerson.showEdit"
                                    >
                                        <p
                                            class="searchs-table-td-name"
                                        >{{ relativePerson.login_user_name }}</p>
                                        <p
                                            class="searchs-table-td-id js-td-text"
                                        >{{ relativePerson.login_name }}</p>
                                    </div>
                                    <input
                                        class="searchs-tr-input g-input"
                                        type="text"
                                        name
                                        v-model="relativePerson.login_name"
                                        v-if="relativePerson.showEdit"
                                    >
                                </td>
                                <td class="searchs-table-receipts searchs-table-td">
                                    <p class="searchs-td-text" v-if="!relativePerson.showEdit">
                                        &yen;
                                        <span
                                            class="searchs-table-num js-td-text"
                                        >{{ relativePerson.amount }}</span>
                                    </p>
                                    <input
                                        class="searchs-tr-input g-input"
                                        type="text"
                                        name
                                        v-model.trim="relativePerson.amount"
                                        v-show="relativePerson.showEdit"
                                    >
                                </td>
                                <td class="searchs-table-explain searchs-table-td">
                                    <p
                                        class="searchs-td-text js-td-text"
                                        v-show="!relativePerson.showEdit"
                                    >{{ relativePerson.task_remark }}</p>
                                    <input
                                        class="searchs-tr-input g-input"
                                        v-show="relativePerson.showEdit"
                                        type="text"
                                        name
                                        v-model="relativePerson.task_remark"
                                    >
                                </td>
                                <td class="searchs-table-state searchs-table-td">
                                    <div class="f-inlineblock-middle state-text">
                                        <p
                                            class="searchs-td-text"
                                        >{{ relativePerson.relationStatusText }}</p>
                                    </div>
                                </td>
                                <td class="searchs-table-operation searchs-table-td">
                                    <div
                                        v-if="authorOrderInfo.isReceiver && authorOrderInfo.order_status==6002"
                                    >
                                        <a
                                            class="g-btn bg-orange js-operation-hold"
                                            href="javascript:;"
                                            v-show="relativePerson.showEdit"
                                            @click="doEditRelativePerson(relativePerson)"
                                        >保存</a>
                                        <a
                                            class="g-btn js-operation-edit"
                                            href="javascript:;"
                                            @click="editRelativePerson(relativePerson)"
                                            v-show="!relativePerson.showEdit"
                                        >编辑</a>
                                        <a
                                            class="g-btn js-operation-delete"
                                            href="javascript:;"
                                            @click="deleteRelativePerson(relativePerson)"
                                        >删除</a>
                                    </div>
                                </td>
                            </tr>
                        </table>

                        <!-- 分页[[ -->
                        <pagination
                            v-if="paginationConf.total >0"
                            :total="paginationConf.total"
                            :page-size="paginationConf.pageSize"
                            @change="pageChange"
                            ref="pager"
                        ></pagination>
                        <!-- 分页]] -->
                    </div>
                    <!-- 空数据 start -->
                    <div class="empty taking-empty" v-if="!relativePersonList.length">
                        <p class="empty-text">暂未添加关联人及金额</p>
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
                    </div>
                    <!-- 空数据 end -->
                </div>
                <div class="footer-bar">
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a
                                class="button f-fr js-return-btn"
                                href="javascript:;"
                                @click="goBack"
                            >返回</a>

                            <!--选中状态  为a标签添加类 active -->
                            <a
                                class="button f-fr confirm-order-btn js-confirm-order-btn"
                                v-if="authorOrderInfo.order_status == 6002"
                                href="javascript:;"
                                @click="acceptOrder"
                            >确认接单</a>
                            <a
                                class="button f-fr statement-btn js-statement-btn"
                                href="javascript:;"
                                @click="submitAuthorOrder(authorOrderInfo)"
                                v-if="authorOrderInfo.order_status == 6006 && authorOrderInfo.isReceiver"
                            >提请结单</a>
                            <a
                                class="button f-fr bg-orange js-contribute-btn"
                                href="javascript:;"
                                v-if="authorOrderInfo.order_status == 6006"
                                @click="contribute(authorOrderInfo)"
                            >投稿</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 关联人及金额]] -->

            <!-- 已提交内容[[ -->
            <div class="order-detail-status order-detail-status-2" v-else>
                <div class="searchs-list">
                    <div class="search f-clearfix">
                        <select-box
                            :selectList="pageConf.articleTypeList"
                            itemTitle="内容类型"
                            :selected.sync="articleParams.type"
                            :placeholder="'请选择内容类型'"
                        ></select-box>
                        <select-box
                            :selectList="pageConf.articleStatusList"
                            itemTitle="内容状态"
                            :selected.sync="articleParams.status"
                            :placeholder="'请选择内容类型'"
                        ></select-box>
                        <div class="list f-fl list-title">
                            <p class="name f-fl">
                                <label for="keyword">订单名称</label>
                            </p>
                            <div class="g-select f-fl">
                                <input
                                    class="input"
                                    name="keyword"
                                    type="text"
                                    placeholder="请输入订单名称"
                                    v-model="articleParams.title"
                                >
                                <!--0629修改-->
                            </div>
                        </div>
                        <div class="inquire f-fr">
                            <input class="btn" type="button" value="查询" @click="queryArticleList">
                        </div>
                    </div>
                    <ul class="freelance-list">
                        <li class="list" v-for="article in articleList" :key="article">
                            <div class="f-clearfix">
                                <p class="pic f-fl">
                                    <img :src="article.cover" width="197" height="111" alt>
                                </p>
                                <div class="txt f-fl">
                                    <!-- 不带原创标签[[ -->
                                    <h3 class="title">
                                        <span class="type">【{{ article.articleTypeText }}】</span>
                                        <a
                                            class="name f-hide-col-1 js-open-view"
                                            href="javascript:;"
                                            @click="previewArticle(article)"
                                        >{{ article.articleTitle }}</a>
                                    </h3>
                                    <!-- 不带原创标签]] -->
                                    <div class="intro">
                                        <!--王者荣耀-->
                                    </div>
                                    <p class="author">
                                        {{ article.userName }}
                                        <span class="time">{{ article.created}}</span>
                                    </p>
                                </div>
                                <div class="examine f-fl">
                                    <a
                                        class="switch js-down1"
                                        href="javascript:;"
                                        @click="article.showMediaDistribute = !article.showMediaDistribute"
                                    >
                                        发布渠道
                                        <i
                                            class="ico"
                                            :class="article.showMediaDistribute ? 'ico-up' : 'ico-down'"
                                        ></i>
                                    </a>
                                </div>
                                <!-- 待审核[[ -->
                                <div
                                    class="operation wait-accept f-fr"
                                    v-if="article.articleStatus ==10 || article.articleStatus == 0"
                                >
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText }}</span>
                                    </p>
                                    <!--<p class="btn">-->
                                    <!--<a class="g-btn" href="javascript:;" @click="editArticle(article)">编辑</a>-->
                                    <!--<a class="g-btn js-open-reject" href="javascript:;" @click="deleteArticle(article)">删除</a>-->
                                    <!--</p>-->
                                </div>
                                <!-- 待审核]] -->
                                <!-- 已通过[[ -->
                                <div class="operation check-passed f-fr" v-else>
                                    <!--<div class="operation reject-more f-fr">-->
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText }}</span>
                                    </p>
                                </div>
                                <!-- 已通过]] -->
                            </div>
                            <ul
                                class="channel f-clearfix js-channel-show1"
                                style="display: block"
                                v-if="article.showMediaDistribute"
                            >
                                <li class="item f-fl" v-for="media in article.media" :key="media">
                                    <span class="head">
                                        <img :src="media.outCover" width="25" height="25">
                                    </span>
                                    <a
                                        class="name js-open-channel"
                                        href="javascript:;"
                                        style="width: 6rem"
                                        @click="showMediaDistributeDialog(media)"
                                        @mouseenter="media.showRemark = true"
                                        @mouseleave="media.showRemark = false"
                                    >{{ media.accountName }}</a>

                                    <span class="sync sync-success" v-if="media.status==1">
                                        同步
                                        <i class="ico ico-success"></i>
                                    </span>
                                    <span class="sync sync-failure" v-else-if="media.status==0">
                                        未同步
                                        <i class="ico ico-failure"></i>
                                    </span>
                                    <span class="sync sync-failure" v-else-if="media.status==3">
                                        同步失败
                                        <i class="ico ico-failure"></i>
                                    </span>
                                    <div
                                        class="sync-failure-reason"
                                        style="display: block"
                                        v-if="media.showRemark && media.remark"
                                    >
                                        <div class="sync-failure-triangle"></div>
                                        <div
                                            class="failure-reason-text f-hide-col-1"
                                        >{{media.remark}}</div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!-- 空数据 start -->
                    <div class="empty" v-if="articleList.length===0">
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
                    </div>
                    <!-- 空数据 end -->
                    <!--内容预览 start-->
                    <content-preview ref="contentPreview"></content-preview>
                    <video-preview ref="videoPreview"></video-preview>
                    <!--内容预览 end-->
                    <media-distribute-info ref="mediaDistributeInfo"></media-distribute-info>
                    <!-- 分页[[ -->
                    <pagination
                        v-if="aPaginationConf.total >0"
                        :total="aPaginationConf.total"
                        :page-size="aPaginationConf.pageSize"
                        @change="aPageChange"
                        ref="pager"
                    ></pagination>
                </div>
            </div>
            <!-- 已提交内容]] -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order_children_detail.scss";
@import "~Assets/sass/pages/v4/order/order_taking.scss";
.searchs-tr-input.g-input {
    line-height: 32px;
    border: 1px solid #efefef;
    padding-left: 5px;
}
.order-children-detail .freelance-list .operation {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .status {
        padding: 0;
    }
}
</style>
<script>
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import contentPreview from "Components/v4/pop/content_preview";
import videoPreview from "Components/v4/pop/video_preview";
import {
    AuthorOrderInfo,
    AuthorOrderArticleList,
    AuthorOrderRelationList,
    AddRelativePerson,
    DeleteRelativePerson,
    ArticleDelete,
    AuthorAcceptOrder,
    AuthorSubmitAuthorOrder,
    AuthorOrderImportTeam
} from "Services/getData.js";
import {
    MAP_ARTICLE_TYPE_LIST,
    MAP_ARTICLE_STATUS_LIST
} from "Services/paramsConfig.js";
import mediaDistributeInfo from "./media_distribute_info";
export default {
    name: "related_author_charge.vue",
    data() {
        return {
            tabList: ["关联人及金额", "已提交内容"],
            curTab: 0,
            pageConf: {
                contentTypeList: [
                    {
                        id: 0,
                        name: "全部类型"
                    },
                    {
                        id: 1,
                        name: "PGC"
                    },
                    {
                        id: 2,
                        name: "PUGC"
                    },
                    {
                        id: 3,
                        name: "UGC"
                    }
                ],
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ],
                articleTypeList: [
                    {
                        name: "请选择",
                        id: ""
                    },
                    {
                        name: "图文",
                        id: 0
                    },
                    {
                        name: "视频",
                        id: 1
                    },
                    {
                        name: "小说",
                        id: 50
                    },
                    {
                        name: "漫画",
                        id: 60
                    }
                ],
                articleStatusList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "草稿中",
                        id: 0
                    },
                    {
                        name: "待审核",
                        id: 10
                    },
                    {
                        name: "外团已通过",
                        id: 15
                    },
                    {
                        name: "供应商已通过",
                        id: 18
                    },
                    {
                        name: "已通过",
                        id: 20
                    },
                    {
                        name: "已发布",
                        id: 30
                    },
                    {
                        name: "已驳回",
                        id: 50
                    },
                    {
                        name: "已定时",
                        id: 40
                    },
                    {
                        name: "已下线",
                        id: 60
                    },
                    {
                        name: "已删除",
                        id: 70
                    }
                ],
                authorOrderStatusList: [
                    {
                        id: 0,
                        name: "全部",
                        enName: "all",
                        num: ""
                    },
                    // {id:6001, name: '制单中', enName: '',operation:['edit','delete']},
                    {
                        id: 6002,
                        name: "待接单",
                        enName: "toReceive",
                        num: "",
                        operation: ["stop"]
                    },
                    {
                        id: 6003,
                        name: "已接单",
                        enName: "hasReceive",
                        num: "",
                        operation: ["stop"]
                    },
                    {
                        id: 6004,
                        name: "待审核",
                        enName: "toAudit",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6005,
                        name: "已驳回",
                        enName: "reject",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6006,
                        name: "执行中",
                        enName: "execute",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6007,
                        name: "待结单",
                        enName: "toFinish",
                        num: "",
                        operation: ["supplierStop"]
                    },
                    {
                        id: 6008,
                        name: "待结算",
                        enName: "toStatement",
                        num: "",
                        operation: ["reject"]
                    },
                    {
                        id: 6009,
                        name: "结算中",
                        enName: "statementing",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6010,
                        name: "支付成功",
                        enName: "paySuccess",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6011,
                        name: "支付失败",
                        enName: "payFailed",
                        num: "",
                        operation: []
                    },
                    // {id:6012, name: '支付中',operation:[]},
                    {
                        id: 6020,
                        name: "已中止",
                        enName: "over",
                        num: "",
                        operation: []
                    },
                    {
                        id: 6021,
                        name: "终止结算",
                        enName: "stopSettle",
                        num: "",
                        operation: []
                    }
                ],
                relationStatusList: {
                    0: "待支付",
                    10: "支付成功",
                    20: "支付失败",
                    30: "终止结算"
                }
            },
            params: {
                authorOrderId: "",
                authorOrderStatus: "",
                gameId: "",
                authorOrderName: "",
                pageSize: 10,
                pageIndex: 0 // 从 0 开始
            },
            articleParams: {
                authorOrderId: "",
                type: "",
                status: "",
                title: "",
                page: 1,
                pageSize: 10
            },
            authorOrderList: [],
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            aPaginationConf: {
                total: 0,
                pageSize: 10
            },
            authorOrderInfoDialog: {
                show: false
            },
            authorOrderInfo: {},
            relativePersonList: [], // 当前订单关联人列表
            articleList: [],
            addBox: {
                show: false,
                id: "",
                authorOrderId: "",
                qq: "",
                amount: "",
                remark: ""
            },
            tmp: {
                demandTypeList: {},
                orderStatusList: {},
                articleTypeMap: {}
            },
            mediaDistributeDialog: {
                show: false,
                outTitle: "",
                outCover: "",
                accountName: "",
                mediaName: ""
            },
            importTeamMembers: []
        };
    },
    components: {
        selectBox,
        pagination,
        contentPreview,
        videoPreview,
        mediaDistributeInfo
    },
    created() {
        this.pageConf.authorOrderStatusList.filter(type => {
            this.tmp.orderStatusList[type.id] = type.name;
        });
    },
    mounted() {
        let authorOrderId = this.$route.query.id; // 传入参数为作者订单
        if (authorOrderId) {
            this.addBox.authorOrderId = authorOrderId;
            this.articleParams.authorOrderId = authorOrderId;
            this.params.authorOrderId = authorOrderId;
            this.getAuthorOrderInfo(authorOrderId).then(() => {
                // 制单中，待接单无法拉取信息
                if (![6001, 6002].includes(this.authorOrderInfo.order_status)) {
                    this.getAuthorOrderArticleList();
                }
                this.getRelativePersonList();
            });
        } else {
            this.$router.go(-1);
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        changeTab(index) {
            this.paginationConf.total = 0;
            this.aPaginationConf.total = 0;
            this.params.pageIndex = 0;
            this.articleParams.page = 1;

            this.curTab = index;
            if (this.curTab) {
                this.getAuthorOrderArticleList();
            } else {
                this.getRelativePersonList();
            }
        },
        editRelativePerson(relativePerson) {
            relativePerson.showEdit = true;
        },
        doEditRelativePerson(relativePerson) {
            let param = {
                id: relativePerson.id,
                authorOrderId: this.authorOrderInfo.id,
                qq: relativePerson.login_name,
                amount: relativePerson.amount,
                remark: relativePerson.task_remark
            };
            if (!relativePerson.login_name || !relativePerson.amount) {
                this.$alert("关联人和金额不能为空~");
                return false;
            }
            this.doSaveRelativePerson(param);
        },
        submitAuthorOrder(order) {
            this.getRelativePersonList(order);
            this.getAuthorOrderInfo(order.id).then(() => {
                this.authorOrderInfoDialog.show = true;
            });
        },
        deleteRelativePerson(relativePerson) {
            this.$confirm(`确认删除此关联人金额吗？`, "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消"
            })
                .then(() => {
                    if (!relativePerson.id) {
                        this.removeCurrentPerson(relativePerson);
                    } else {
                        this.doDeleteRelativePerson(relativePerson);
                    }
                })
                .catch(() => {});
        },
        acceptOrder() {
            let allHasSaved = true;
            this.relativePersonList.filter(p => {
                if (p.showEdit) {
                    allHasSaved = false;
                }
            });
            if (!allHasSaved) {
                this.$alert("存在未保存的关联人信息,请先保存~");
                return false;
            }
            this.$confirm(
                `确认接单后，关联人及金额就无法修改了，相关关联人会接收到此订单，您确认接单么？`,
                "提示",
                {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消"
                }
            )
                .then(() => {
                    this.doAcceptAuthorOrder();
                })
                .catch(() => {});
        },
        showAddPersonBox() {
            this.addBox.show = true;
        },
        importTeamMember() {
            this.getAuthorOrderTeamMember(this.authorOrderInfo.id).then(() => {
                this.updateRelativePersonList();
            });
        },
        updateRelativePersonList() {
            let relativePersonExist = [];
            this.relativePersonList.filter(p => {
                relativePersonExist.push(p.login_name);
            });
            if (this.importTeamMembers.length) {
                this.importTeamMembers.filter(t => {
                    if (!relativePersonExist.includes(t.loginName)) {
                        let person = {};
                        person.showEdit = true;
                        person.id = "";
                        person.task_remark = "";
                        person.amount = "";
                        person.login_name = t.loginName;
                        this.relativePersonList.push(person);
                    }
                });
            }
        },
        resetAddBox() {
            this.addBox.id = "";
            this.addBox.remark = "";
            this.addBox.qq = "";
            this.addBox.amount = "";
            this.addBox.show = false;
        },
        saveAddPersonBox() {
            let {
                id, qq, remark, amount 
            } = this.addBox;
            if (!qq || !amount) {
                this.$alert("关联人和金额不能为空~");
                return false;
            }
            let param = {
                authorOrderId: this.authorOrderInfo.id,
                qq,
                id,
                remark,
                amount
            };
            this.doSaveRelativePerson(param);
        },
        saveRelativePerson(person) {
            let {
                id, login_name, task_remark, amount 
            } = person;
            if (!login_name || !amount) {
                this.$alert("关联人和金额不能为空~");
                return false;
            }
            let param = {
                authorOrderId: this.authorOrderInfo.id,
                qq: login_name,
                id,
                remark: task_remark,
                amount
            };
            this.doSaveRelativePerson(param);
        },
        showMediaDistributeDialog(media) {
            this.$refs.mediaDistributeInfo.show(media);
        },
        editArticle(article) {
            this.$router.history.push({
                name: "v4-order-contribute",
                query: {
                    articleId: article.id
                }
            });
        },
        contribute(authorOrder) {
            // 作者订单投稿
            this.$router.history.push({
                name: "v4-order-contribute",
                query: {
                    authorOrderId: authorOrder.id
                }
            });
        },
        deleteArticle(article) {
            this.$confirm("确认删除此内容吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false
            })
                .then(() => {
                    this.doDeleteArticle(article.id);
                })
                .catch(() => {});
        },
        previewArticle(article) {
            if (article.articleType == 1) {
                this.$refs.videoPreview.remotePreview(article.id);
            } else {
                this.$refs.contentPreview.loadInfo(article.id);
            }
        },
        aPageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.articleParams.page = param.pageIndex; // 发送给接口的字段
            this.getAuthorOrderArticleList();
        },
        pageChange(param) {
            this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.getRelativePersonList();
        },
        removeCurrentPerson(relativePerson) {
            let index = this.relativePersonList.indexOf(relativePerson);
            this.relativePersonList.splice(index, 1);
        },
        queryArticleList() {
            this.params.page = 1;
            this.getAuthorOrderArticleList();
        },
        async doAcceptAuthorOrder() {
            let response = await AuthorAcceptOrder({
                authorOrderId: this.authorOrderInfo.id
            });
            if (response.data.code === 0) {
                this.$alert("操作成功");
                // this.goBack();
                this.getAuthorOrderInfo(this.authorOrderInfo.id);
                this.getRelativePersonList();
            }
        },
        async getAuthorOrderTeamMember(authorOrderId) {
            let response = await AuthorOrderImportTeam({
                authorOrderId
            });
            if (response.data.code === 0) {
                this.importTeamMembers = response.data.data;
            }
        },
        async doDeleteArticle(id) {
            let res = await ArticleDelete(id);
            if (res.status === 200 && res.data && res.data.code == 0) {
                this.$alert("操作成功");
            }
            this.getSupplierOrderArticleList();
        },
        async doSaveRelativePerson(param) {
            // 保存关联人信息
            let response = await AddRelativePerson(param);
            let result = response.data;
            let {
                authorOrderId, qq, id, remark, amount 
            } = param;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.resetAddBox();
                this.relativePersonList.filter(person => {
                    if (person.login_name == qq) {
                        this.removeCurrentPerson(person);
                    }
                });
                this.getRelativePersonList();
            }
        },
        async doSubmitAuthorOrder(id) {
            // 提请结单
            let response = await AuthorSubmitAuthorOrder({
                authorOrderId: id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.authorOrderInfoDialog.show = false;
                this.getRelativePersonList();
                this.getAuthorOrderInfo(id);
            }
        },
        async doDeleteRelativePerson(relativePerson) {
            // 保存关联人信息
            let response = await DeleteRelativePerson({
                authorOrderId: this.authorOrderInfo.id,
                relationId: relativePerson.id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.removeCurrentPerson(relativePerson);
            }
        },
        async getAuthorOrderInfo(authorOrderId) {
            let res = await AuthorOrderInfo({
                authorOrderId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    let demandTypeList = {};
                    this.pageConf.demandTypeList.filter(type => {
                        demandTypeList[type.id] = type.name;
                    });
                    data.demandTypeText = demandTypeList[data.demand_type];
                    this.authorOrderInfo = data;
                }
            }
        },
        async getRelativePersonList() {
            let res = await AuthorOrderRelationList(this.params);
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    let hasSavedLoginNames = [];
                    let relativePersonListMap = new Map();
                    let relativePersonList = data.data.map(p => {
                        p.relationStatusText = this.pageConf.relationStatusList[
                            p.relation_status
                        ];
                        p.orderStatusText = this.tmp.orderStatusList[
                            p.order_status
                        ];
                        p.showEdit = false;
                        hasSavedLoginNames.push(p.login_name);
                        relativePersonListMap.set(p.login_name, p);
                        return p;
                    });
                    // 填补待保存的数据
                    let unSavePerson = [];
                    this.relativePersonList.filter(p => {
                        if (!p.id) {
                            unSavePerson.push(p);
                        }
                    });
                    this.relativePersonList = relativePersonList.concat(
                        unSavePerson
                    );
                }
                this.paginationConf.total = res.data.data.count;
            }
        },
        async getAuthorOrderArticleList() {
            let res = await AuthorOrderArticleList(this.articleParams);
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let data = res.data.data;
                    this.articleList = data.data.map(article => {
                        if (
                            MAP_ARTICLE_STATUS_LIST.has(article.articleStatus)
                        ) {
                            article.articleStatusText = MAP_ARTICLE_STATUS_LIST.get(
                                article.articleStatus
                            );
                        }
                        if (MAP_ARTICLE_TYPE_LIST.has(article.articleType)) {
                            article.articleTypeText = MAP_ARTICLE_TYPE_LIST.get(
                                article.articleType
                            );
                        }
                        article.showMediaDistribute = false;
                        if (article.mediaDistribute) {
                            article.mediaDistribute.map(media => {
                                media.showRemark = false;
                                return media;
                            });
                        }
                        return article;
                    });
                    this.aPaginationConf.total = data.total;
                }
            }
        }
    },
    watch: {},
    computed: {
        getAuthorOrderTax() {
            let {
                realAmountTax, realAmount 
            } = this.authorOrderInfo;
            if (isNaN(realAmountTax) || isNaN(realAmount)) {
                return "0.00";
            }
            return this.$common.toThousandsFilter(realAmountTax - realAmount);
        }
    }
};
</script>

